import { css } from 'styled-components'
import transformProps from '../utils/transformProps'
import { ConfigType, Dictionary, StyleType } from '../utils/transformProps/types'

type FontKeys = 'fontFamily'
type TextAlignKey = 'textAlign'
type FontWeightKey = 'fontWeight'

type BasicTypographyKeys = 'fontSize' | 'lineHeight'

export type TypographyKeys = FontKeys | BasicTypographyKeys | FontWeightKey | TextAlignKey

type FontFamilyProp = {
    [key in FontKeys]?: string
}

type TextAlignProp = {
    [key in TextAlignKey]?: 'center' | 'right' | 'left'
}

type AdditionalFontStyleProps = {
    [key in FontWeightKey]?: string | string[]
}

export type TypographyProps = FontFamilyProp &
    AdditionalFontStyleProps &
    TextAlignProp & {
        [key in BasicTypographyKeys]?: Dictionary
    }

export const typographyConfig: ConfigType<TypographyKeys> = {
    fontFamily: {
        property: ['fontFamily'],
    },
    fontSize: {
        property: ['fontSize'],
        scale: 'fontSizes',
    },
    lineHeight: {
        property: ['lineHeight'],
        scale: 'lineHeights',
    },
    fontWeight: {
        property: ['fontWeight'],
    },
    textAlign: {
        property: ['textAlign'],
    },
}

export const typography = css<TypographyProps>`
    ${(props): StyleType => transformProps(typographyConfig, props)}
`
